export default __webpack_public_path__ + "static/media/ruler.b0914673.svg";